import script from "./EditPostContent.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPostContent.vue?vue&type=script&setup=true&lang=js"

import "./EditPostContent.vue?vue&type=style&index=0&id=ac623508&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac623508"]])

export default __exports__